<template>
  <div class="all-ease">
    <div class='px-24 mb-px-16 overflow-auto' :style='isDesktop || formData.isUIPopup ? `height: ${formData.heightForm}px` : ""'>
      <div :class="formData.labelClass?.stepsLabel">STEP {{ indexCurrentStep }} OF 5</div>
      <div :class="formData.labelClass?.titleClass" class="flex items-center">
        <template v-if="showPriceRange">
          Estimated Price In <DropdownCurrency :showBorder='true' classButton="px-8 bg-gray-new br-1000 ml-8" classButtonText="fw-700 fs-28 lh-32 mr-4 gray-900 mb-fs-18 mb-lh-28" />
        </template>
        <template v-else> Your Budget </template>
      </div>
      <div :class="[formData.labelClass?.subTitleClass, formData.labelClass?.divider]">
        {{ showPriceRange ? 'This is customisable to fit your preferences and budget.' : 'Let us know your ideal budget for this trip' }}
      </div>
      <div v-show="!state.apiLoading" class="py-20">
        <div class="relative">
          <div class="content-form">
            <template v-if="showPriceRange">
              <div class="px-10 py-16 bg-gray-50 bd-1 bd-gray-200 br-8">
                <div class="flex items-center">
                  <ToggleButton @click="handTrackPriceMode" v-model:checked="state.showPricePerPerson" id="enquiry-form-toggle-switch-price-mode" :checkInit="state.showPricePerPerson" />
                  <div class="fw-500 pl-8 gray-700 fs-14 lh-20">{{ labelViewProce }}</div>
                </div>
                <div class="fw-700 gray-900 fs-20 lh-28 mt-12">{{ displayPriceRange }}</div>
              </div>
              <div class='fs-14 lh-20 gray-700-brand mt-16'>
                The estimated range is based on various trips we've built for past travellers and your selections for accommodation types, travel dates, and number of travellers.Let us know how much you hope to spend on your trip. This way, we can include what suits you but stays within your means.
              </div>
              <div class="flex items-center mt-16">
                <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2709_34682)">
                    <path
                      d="M8 12C8.41421 12 8.75 11.6642 8.75 11.25C8.75 10.8358 8.41421 10.5 8 10.5C7.58579 10.5 7.25 10.8358 7.25 11.25C7.25 11.6642 7.58579 12 8 12Z"
                      fill="#0F5AA3"
                    />
                    <path
                      d="M8 9V8.5C9.10438 8.5 10 7.71625 10 6.75C10 5.78375 9.10438 5 8 5C6.89562 5 6 5.78375 6 6.75V7"
                      stroke="#0F5AA3"
                      stroke-width="0.875"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                      stroke="#0F5AA3"
                      stroke-width="0.875"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2709_34682">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span
                  id="enquiry-form-hyperlink-why-price-range"
                  class="ml-4 fw-500 fs-16 lh-24 mb-fs-14 mb-lh-20 hand brand-green underline"
                  @click.prevent="triggerBottomSheetPriceRange(true)"
                >
                  Why is this a price range?
                </span>
              </div>
<!--              <label ref="approvePriceRef" :class="formData.labelClass?.cssLabelField" class="mt-16">Is this the price range you had in mind?</label>-->
<!--              <RadioBox-->
<!--                v-for="(item, index) in radioList"-->
<!--                :key="index"-->
<!--                :label="item.label"-->
<!--                :value="item.value"-->
<!--                name="approvePrice"-->
<!--                class="mb-8"-->
<!--                :isChecked="dataStep.approvePrice === item.value"-->
<!--                v-model:change="dataStep.approvePrice"-->
<!--              />-->
<!--              <div class="error-message" v-if="(errors as any).approvePrice">Let us know if the price range works for you.</div>-->
            </template>
            <div class="all-ease" :class="'o-100'">
<!--              <template v-if="showFieldBudget">-->
                <template v-if="isDesktop">
                  <label ref="budgetRef" :class="formData.labelClass?.cssLabelField.replace('mb-4', '')" class="mt-16">
                    {{ labelBudget }}
                    <span :class="formData.labelClass?.cssLabelOptionField">{{ showPriceRange ? '(excluding international flights)' : '' }} </span>
                  </label>
                </template>
                <template v-else>
                  <label ref="budgetRef" :class="formData.labelClass?.cssLabelField.replace('mb-4', '')" class="mt-16">
                    {{ labelBudget }}
                    <!-- <span v-if="!showPriceRange" :class="formData.labelClass?.cssLabelOptionField">(*optional)</span> -->
                  </label>
                  <span v-if="showPriceRange" :class="formData.labelClass?.cssLabelOptionField" class="mt-4 db">(excluding international flights)</span>
                </template>
                <div class="flex items-start mt-16" :class="!showPriceRange">
<!--                  <span v-if="showPriceRange" class="pa-12 bg-gray-50 bd-1 bd-gray-medium br-6 fs-14 mr-8">{{ selectedCurrency.code }}</span>-->
                  <DropdownCurrency v-if="!showPriceRange" :showCodeCurrent="true" classButton="pa-12 bg-gray-50 bd-1 bd-gray-medium br-6 fs-14 mr-8" classButtonText="fw-400 fs-14" :showDropdownRight="false" />
                  <div class="wp-100">
                    <Input type="number" placeholder="0" v-model="dataStep.budget" @blur="validateInputBudget" />
                    <div class="error-message" v-if="(errors as any).budget">Let us know your ideal budget.</div>
                  </div>
                </div>
<!--              </template>-->
              <div class='fs-14 lh-20 gray-700-brand mt-16' v-if="!showPriceRange">
                Let us know how much you hope to spend on your trip. This way, we can include what suits you but stays within your means. <br/>No worries if you can't decide yet; we are here to help.
              </div>
            </div>
            <div v-if="error" class="pb-30 red error-bottom">{{ error }}</div>
          </div>
        </div>
      </div>
    </div>
    <FooterSteps
      :disableSubmitButton="disableSubmitButton"
      :labelClass="formData.labelClass"
      :stepActive="EnquiryStepEnum.YourBudget"
      :isUIPopup='formData.isUIPopup'
      :button-id="`enquiry-form-button-continue-step${indexCurrentStep}`"
      @nextStep="nextStep"
      @prevStep="emitPreStep()"
    />
    <BottomSheet v-if="!isDesktop" v-model:visible="state.showBottomSheetPriceRange" height="625px">
      <template #content>
        <SectionContentPriceRange :destination="destinationName" @close="triggerBottomSheetPriceRange(false)" />
      </template>
    </BottomSheet>
    <ModalWhyPriceRange v-else :visible="state.showBottomSheetPriceRange" :destination="destinationName" @close="triggerBottomSheetPriceRange(false)" />
  </div>
</template>
<script setup lang="ts">
import { ref, computed, watch, reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import DropdownCurrency from '~/components/globals/Header/elements/DropdownCurrency/DropdownCurrency.vue'
import ModalWhyPriceRange from '~/components/pages/Enquiry/MultiStepsForm/Elements/ModalWhyPriceRange.vue'
import SectionContentPriceRange from '~/components/pages/Enquiry/MultiStepsForm/Elements/SectionContentPriceRange.vue'
import FooterSteps from '~/components/pages/Enquiry/MultiStepsForm/Steps/FooterSteps.vue'
import BottomSheet from '~/components/ui/bottom-sheet/BottomSheet.vue'
import Input from '~/components/ui/input/Input.vue'
// import RadioBox from '~/components/ui/radio-box/RadioBox.vue'
import ToggleButton from '~/components/ui/toggle-button/ToggleButton.vue'
import enquiryTravellerApi from '~/composables/api/enquiryTravellerApi'
import { DESKTOP } from '~/constant/common'
import { EnquiryStepEnum } from '~/enum/enquiry'
import { exchangeRate, formatCurrency, isDeepEqual, isEmpty } from '~/helper'
import useFormValidation from '~/utils/validators'
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import { getEnquiryID } from '~/helper/enquiry'
import { useCurrenciesStore } from '~/store/pinia/currencies'
import { useEnquiryCaptureStore } from '~/store/pinia/enquiryCapture'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

// const radioList = [
//   {
//     label: 'Yes, it’s close',
//     value: 'yes',
//   },
//   {
//     label: 'Not quite',
//     value: 'no',
//   },
// ]
// props & emits
defineProps({
  formData: { type: Object, default: () => {} },
})
const emits = defineEmits(['prevStep', 'nextStep', 'completed'])

// define
const firstIndex = 0
const route = useRoute()
const { validateNumberField, errors } = useFormValidation()
const currenciesStore = useCurrenciesStore()
const enquiryCaptureStore = useEnquiryCaptureStore()
const generalStore = useGeneralInfoStore()

const state = reactive({
  showBottomSheetPriceRange: false,
  showPricePerPerson: true,
  apiLoading: false,
  priceRange: null as null | { max_price: string | number; min_price: string | number; currency: string },
})
const dataStep = reactive({
  approvePrice: null as 'yes' | 'no' | null,
  budget: null as number | null,
  redirect_url: '/design/confirmation',
})
const budgetRef = ref<HTMLElement | null>()
// const approvePriceRef = ref<HTMLElement | null>()
const disableSubmitButton = ref(false)
const error = ref('')
const priceRangeAPI = ref<{ maxPrice: string | number; minPrice: string | number; currency: string } | null>(null)
const paramsPriceRange = ref<{ country_code: string; month: string; currency: string; hotel_star: string } | null>(null)

// computed
const arrayStepEnquiry = computed(() => enquiryCaptureStore.arrayStep)
const labelViewProce = computed(() => (state.showPricePerPerson ? `You’re Viewing Price Per Person` : 'You’re Viewing Total Price'))
const labelBudget = computed(() =>
  state.showPricePerPerson
    ? `My ideal budget, per person in ${selectedCurrency.value.code}`
    : `My ideal budget for ${countTravellers.value} ${countTravellers.value === 1 ? 'traveller' : 'travellers'}`,
)
const selectedCurrency = computed(() => {
  // return store.getters['currenciesStore/getCurrencySelected']
  return currenciesStore.getCurrencySelected
})
const windowWidth = computed(() => generalStore.generalData.windowWidth)
const isDesktop = computed(() => windowWidth.value > DESKTOP)
const dataStepYourTrip = computed(() => {
  return enquiryCaptureStore.enquiryDataByStep(route.path, EnquiryStepEnum.YourTrip)
})
const destinationName = computed(() => {
  if (dataStepYourTrip.value && dataStepYourTrip.value.destination) {
    return dataStepYourTrip.value.destination.map((v: any) => v.name).join(', ')
  }
  return ''
})
const lengthOfTrip = computed(() => {
  if (dataStepYourTrip.value) {
    return dataStepYourTrip.value.lengthOfTrip
  }
  return 1
})
const dataStepHow = computed(() => {
  return enquiryCaptureStore.enquiryDataByStep(route.path, EnquiryStepEnum.How)
})
const countTravellers = computed(() => {
  if (!dataStepHow.value) return 0
  return dataStepHow.value.pax
})
// const showFieldBudget = computed(() => dataStep.approvePrice === 'no' || !state.priceRange)
const showPriceRange = computed(() => !!priceRangeAPI.value)
const displayPriceRange = computed(() => {
  if (!state.priceRange) return ''
  const { min_price, max_price } = state.priceRange
  // const code = selectedCurrency.value.code
  const symbol = selectedCurrency.value.symbol
  const min = (min_price as number) * lengthOfTrip.value
  const max = (max_price as number) * lengthOfTrip.value

  if (state.showPricePerPerson) {
    // price = price_org * day_of_trip
    return `${formatCurrency(min, symbol)} ~ ${formatCurrency(max, symbol)}`
  } else {
    // price = price_org * day_of_trip * number_traveller
    return `${formatCurrency(min * countTravellers.value, symbol)} ~ ${formatCurrency(max * countTravellers.value, symbol)}`
  }
})
// const currenciesListData = computed(() => store.getters['currenciesStore/getCurrenciesList'])
const currenciesListData = computed(() => currenciesStore.getCurrenciesList)
const stepOld = computed(() => enquiryCaptureStore.stepsData)
const stepBefore = computed(() => {
  if (stepOld.value && stepOld.value[route.path.toString()] && stepOld.value[route.path.toString()][EnquiryStepEnum.YourBudget])
    return stepOld.value[route.path.toString()][EnquiryStepEnum.YourBudget]
  return {}
})
const currentStep = computed(() => {
  if (stepOld.value && stepOld.value[route.path.toString()]) return stepOld.value[route.path.toString()].step
  return arrayStepEnquiry.value[firstIndex]
})
const indexCurrentStep = computed(() => arrayStepEnquiry.value.indexOf(EnquiryStepEnum.YourBudget) + 1)

// method
const handTrackPriceMode = () => {
  debounceAmplitudeScriptTracking("Switch Price Mode", {
    price_mode: state.showPricePerPerson ? 'price_per_person' : 'total_price',
  })
}
const nextStep = async () => {
  if (validationField()) return
  try {
    disableSubmitButton.value = true
    const predict_price_range = state.priceRange ? `${state.priceRange.min_price}|${state.priceRange.max_price}` : ''
    const payload = {
      path: route.path.toString(),
      step: EnquiryStepEnum.YourBudget,
      [EnquiryStepEnum.YourBudget]: {
        predict_price_range,
        has_budget: 1, //dataStep.approvePrice === 'yes' ? 1 : 0,
        budget: state.showPricePerPerson ? dataStep.budget : undefined,
        total_budget: state.showPricePerPerson ? undefined : dataStep.budget,
        budget_currency: selectedCurrency.value.code,
      },
      redirect_url: dataStep.redirect_url,
    }
    const stepEdit = isDeepEqual(stepBefore.value, dataStep)
    if (!stepEdit) {
      const step = await enquiryCaptureStore.submitEnquiryCapture({ payload, dataStep })
      if (step?.status === 200) {
        debounceAmplitudeScriptTracking('View Enquiry (Estimated Price & Budget)', {
          enquiry_id: getEnquiryID(route.path),
        })
        error.value = ''
        emits('nextStep')
      } else {
        error.value = step?.message || ''
        throw new Error(`submit enquiry step ${EnquiryStepEnum.YourBudget} error (data):`, {
          cause: {
            data: step,
            payload: payload,
          },
        })
      }
    }
  } catch (error) {
    console.log({ error })
    throw new Error(`submit enquiry step ${EnquiryStepEnum.YourBudget} error:`, { cause: error })
  } finally {
    disableSubmitButton.value = false
  }
}

function validateInputBudget() {
  // if (dataStep.approvePrice === 'no' && priceRangeAPI.value) {
  // if (priceRangeAPI.value) {
    validateNumberField('budget', dataStep.budget)
  // }
}
// function validateApprovePrice() {
//   ;(errors as any).approvePrice = dataStep.approvePrice === null && priceRangeAPI.value
// }

function validationField() {
  validateInputBudget()
  // validateApprovePrice()

  if ((errors as any).budget) {
    budgetRef.value && budgetRef.value.scrollIntoView({ behavior: 'smooth' })
    return true
  }
  // if ((errors as any).approvePrice) {
  //   approvePriceRef.value && approvePriceRef.value.scrollIntoView({ behavior: 'smooth' })
  //   return true
  // }

  return (errors as any).budget // || (errors as any).approvePrice
}

function triggerBottomSheetPriceRange(value: boolean) {
  state.showBottomSheetPriceRange = value
}

async function getEnquiriesPriceRanges() {
  try {
    if (!dataStepYourTrip.value || !dataStepHow.value) return
    const { destination, ddMMMYYYY, dateSelected } = dataStepYourTrip.value
    const { accm_pref } = dataStepHow.value
    if (destination.length > 1) {
      priceRangeAPI.value = null
      state.priceRange = null
      return
    }
    const country_code = destination.length ? destination[0].country_code : undefined
    let month = ddMMMYYYY ? ddMMMYYYY : undefined
    const hotel_star = accm_pref ? accm_pref.join('|') : undefined
    if (!month && dateSelected) {
      const arrDate = dateSelected.split('-')
      month = `${arrDate[1]}-${arrDate[0]}`
    }

    const params = { country_code, month, currency: selectedCurrency.value.code, hotel_star }
    const stepEdit = paramsPriceRange.value ? isDeepEqual(paramsPriceRange.value, params) : false
    if (stepEdit) return
    state.apiLoading = true
    const { data: res } = await enquiryTravellerApi.getEnquiriesPriceRange(params)
    if (res.success) {
      if (res.data) {
        state.priceRange = res.data
        priceRangeAPI.value = { ...res.data, maxPrice: res.data.max_price, minPrice: res.data.min_price }
      } else {
        state.priceRange = null
        priceRangeAPI.value = null
      }
      dataStep.approvePrice = null
      dataStep.budget = null
      paramsPriceRange.value = params
      state.showPricePerPerson = true
    }
  } catch (error) {
    console.log({ error })
  } finally {
    state.apiLoading = false
  }
}

const emitPreStep = () => {
  errors.budget = null
  emits('prevStep')
}

watch(
  () => currentStep.value,
  (value) => {
    if (EnquiryStepEnum.YourBudget === value) {
      getEnquiriesPriceRanges()
    }
  },
)

watch(
  () => state.showPricePerPerson,
  () => {
    dataStep.budget = null
  },
)

watch(
  () => dataStep.approvePrice,
  () => {
    ;(errors as any).budget = null
    ;(errors as any).approvePrice = null
    dataStep.budget = null
  },
)

watch(
  () => selectedCurrency.value,
  (newValue, oldValue) => {
    if (!priceRangeAPI.value) return
    const { minPrice, maxPrice, currency } = priceRangeAPI.value
    if (newValue?.code !== oldValue?.code && newValue?.code !== currency) {
      const originalCurrency = currenciesListData.value.find((item: any) => item.code === currency)
      const { rate } = currenciesListData.value.find((item: any) => item.code === newValue.code)

      state.priceRange!.min_price = exchangeRate(parseFloat(minPrice as string), originalCurrency.rate, rate, false, true, false)
      state.priceRange!.max_price = exchangeRate(parseFloat(maxPrice as string), originalCurrency.rate, rate, false, true, false)
    } else {
      state.priceRange!.min_price = minPrice
      state.priceRange!.max_price = maxPrice
    }
  },
)

onMounted(() => {
  getEnquiriesPriceRanges()
})
</script>
<style lang="scss" scoped></style>
